import { render } from "./index.vue?vue&type=template&id=cdd6b7e0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/tab-nav/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cdd6b7e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cdd6b7e0', __exports__)) {
    api.reload('cdd6b7e0', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=cdd6b7e0", () => {
    api.rerender('cdd6b7e0', render)
  })

}


export default __exports__